var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardLeftbarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2660_10587)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2660_10587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.49976 9.62421H1.74976V12.2492H3.49976V9.62421ZM7.87476 6.12421H6.12476V12.2492H7.87476V6.12421ZM12.2498 1.74921V12.2492H10.4998V1.74921H12.2498ZM10.4998 0.874207C10.2677 0.874207 10.0451 0.966394 9.88104 1.13049C9.71694 1.29458 9.62476 1.51714 9.62476 1.74921V12.2492C9.62476 12.4813 9.71694 12.7038 9.88104 12.8679C10.0451 13.032 10.2677 13.1242 10.4998 13.1242H12.2498C12.4818 13.1242 12.7044 13.032 12.8685 12.8679C13.0326 12.7038 13.1248 12.4813 13.1248 12.2492V1.74921C13.1248 1.51714 13.0326 1.29458 12.8685 1.13049C12.7044 0.966394 12.4818 0.874207 12.2498 0.874207H10.4998ZM5.24976 6.12421C5.24976 5.89214 5.34194 5.66958 5.50604 5.50549C5.67013 5.34139 5.89269 5.24921 6.12476 5.24921H7.87476C8.10682 5.24921 8.32938 5.34139 8.49347 5.50549C8.65757 5.66958 8.74976 5.89214 8.74976 6.12421V12.2492C8.74976 12.4813 8.65757 12.7038 8.49347 12.8679C8.32938 13.032 8.10682 13.1242 7.87476 13.1242H6.12476C5.89269 13.1242 5.67013 13.032 5.50604 12.8679C5.34194 12.7038 5.24976 12.4813 5.24976 12.2492V6.12421ZM0.874756 9.62421C0.874756 9.39214 0.966943 9.16958 1.13104 9.00549C1.29513 8.84139 1.51769 8.74921 1.74976 8.74921H3.49976C3.73182 8.74921 3.95438 8.84139 4.11847 9.00549C4.28257 9.16958 4.37476 9.39214 4.37476 9.62421V12.2492C4.37476 12.4813 4.28257 12.7038 4.11847 12.8679C3.95438 13.032 3.73182 13.1242 3.49976 13.1242H1.74976C1.51769 13.1242 1.29513 13.032 1.13104 12.8679C0.966943 12.7038 0.874756 12.4813 0.874756 12.2492V9.62421Z",
    fill: "#212529"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2660_10587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2660_10587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLeftbarIcon);
export default __webpack_public_path__ + "static/media/dashboard_leftbar_icon.a70461a3f846ed82d813ccddad022c9b.svg";
export { ForwardRef as ReactComponent };